<script>
    import Bicycle from "./svg/icons/Bicycle.svelte";
    import ShareIcon from "./svg/icons/files/ShareIcon.svelte";
    import { appManager } from "./AppManagerStore";
    import { _ } from "svelte-i18n";
  </script>

<section id="gis" class="py-8 py-md-11">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-12 col-md-5 col-lg-6 order-md-2">
        <div class="w-md-150 w-lg-130 mb-6 mb-md-0">
          <div class="device-combo device-combo-iphonex-macbook">
            <div class="device device-macbook">
              <img
                src="img/screenshots/desktop/qgis/qgis1.png"
                class="device-screen"
                alt="{$_('gis.image.macbook.alt')}" />
              <img src="img/devices/macbook.svg" class="img-fluid" alt="{$_('gis.image.device.alt')}" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-7 col-lg-6 order-md-1">
        <span class="badge rounded-pill bg-primary-soft mb-1">
          <span class="h6 text-uppercase">{$_('gis.badge.label')}</span>
        </span>
        <h1>{$_('gis.title')} <span class="text-primary">{$_('gis.highlightedTitle')}</span></h1>
  
        <p class="fs-lg text-muted mb-6">
          {$_('gis.description.part1')}
        </p>

        <p class="fs-lg text-muted mb-6">
          {$_('gis.description.part2')}
        </p>

        <h2>{$_('gis.subSection.title')}</h2>

        <p class="fs-lg text-muted mb-6">
          {$_('gis.subSection.description.part1')}
        </p>

        <p class="fs-lg text-muted mb-6">
          {$_('gis.subSection.description.part2')}
        </p>
      </div>
    </div>
  </div>
</section>

  